import { BETTINGWEBSITEFEATUREGQLSCHEMA } from "./BettingWebsite.Feature";
import { BETTINGWEBSITELANGUAGEGQLSCHEMA } from "./BettingWebsite.Language";
import { BETTINGWEBSITEPAYMENTGATEWAYGQLSCHEMA } from "./BettingWebsite.PaymentGateway";
import { BETTINGWEBSITEQANDAGQLSCHEMA } from "./BettingWebsite.QAndA";
import { MULTILANGUAGEGQLSCHEMA } from "./MultiLanguage";

export const BETTINGWEBSITEDESCRIPTIONGQLSCEHMA = `
Short{
  ${MULTILANGUAGEGQLSCHEMA}
}
Long{
  ${MULTILANGUAGEGQLSCHEMA}
}
`;
export const BETTINGWEBSITEMAININFOGQLSCHEMA = `
Title{
  ${MULTILANGUAGEGQLSCHEMA}
}
Description{
  ${BETTINGWEBSITEDESCRIPTIONGQLSCEHMA}
}
Image
`;

export const BETTINGWEBSITERATINGSUBRATESGQLSCHEMA = `
Secuirity
Reputation
Transparency
Popularity
UserExperience
UserInterface
BonusAmount
VarietyOfOptions
MarketDiversity
TransactionSpeed
BettingOdds
SupportQuality
BonusType
VarietyOfTransactionMethods
`;

export const BETTINGWEBSITERATINGGQLSCHEMA = `
TotalRate
SubRates{
  ${BETTINGWEBSITERATINGSUBRATESGQLSCHEMA}
}
`;

export const BETTINGWEBSITEQUESTIONANDANSWERGQLSCHEMA = `
Question{
  ${BETTINGWEBSITEQANDAGQLSCHEMA}
}
Answer
`;

export const BETTINGWEBSITECONTACTSGQLSCHEMA = ` 
Email
Web
Facebook
Telegram
Instagram
X
`;

export const BETTINGWEBSITEGQLSCHEMA = `
id
MainInfo{
    ${BETTINGWEBSITEMAININFOGQLSCHEMA}
}
Features{
    ${BETTINGWEBSITEFEATUREGQLSCHEMA}
}
Languages{
    ${BETTINGWEBSITELANGUAGEGQLSCHEMA}
}
PaymentGateways{
    ${BETTINGWEBSITEPAYMENTGATEWAYGQLSCHEMA}
}
Ratings{
    ${BETTINGWEBSITERATINGGQLSCHEMA}
}
QAndA{
    ${BETTINGWEBSITEQUESTIONANDANSWERGQLSCHEMA}
}
Contacts{
    ${BETTINGWEBSITECONTACTSGQLSCHEMA}
}
`;
